import React from "react";

import DeletedPressBoundary from "@/components/shared/business/DeletedPressBoundary/DeletedPressBoundary";
import EditArticleArticleIdGuard from "@EditArticleContainer/components/EditArticleArticleIdGuard/EditArticleArticleIdGuard";

import EditArticleContainer from "../components/business/EditArticleContainer/EditArticleContainer";

const EditArticlePage = () => {
  return (
    <EditArticleArticleIdGuard>
      <DeletedPressBoundary>
        <EditArticleContainer />
      </DeletedPressBoundary>
    </EditArticleArticleIdGuard>
  );
};

export default EditArticlePage;
